<template>
  <transition :name="name" :css="enable">
    <slot />
  </transition>
</template>

<script>

export default {
  name: 'SlideTransition',
  data() {
    return {
      name: ''
    }
  },
  computed: {
    enable: {
      get() {
        return !(this.$swipeNaved || this.$isEdgeLeft || this.$isEdgeRight)
      },
      set(newVal) {
        this.$swipeNaved = !newVal
      }
    },
  },
  watch: {
    '$route' (to, from) {
      if (!this.enable) {
        this.name = ''
        return
      }
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      if (from.path === '/' && toDepth - fromDepth > 1) { // for stop animation when reload
        this.enable = false
        this.name = ''
      } else {
        if (toDepth === fromDepth) {
          this.name = to.path < from.path ? 'slide-right' : 'slide-left'
        } else {
          this.name = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        }
      }
    }
  }
}
</script>

<style scoped>
.slide-left-enter {
  position: absolute;
}
.slide-left-enter-active {
  position: relative;
  left: 100vw;
  transition: transform .5s;
}
.slide-left-leave-active {
  position: absolute;
  width: 100vw;
  transition: transform .5s;
  z-index: -1;
}
.slide-left-enter-to {
  transform: translateX(-100vw);
}
.slide-left-leave-to {
  transform: translateX(-40vw);
}
.slide-right-enter {
  position: absolute;
}
.slide-right-enter-active {
  position: relative;
  left: -100vw;
  transition: transform .5s;
}
.slide-right-leave-active {
  position: absolute;
  width: 100vw;
  transition: transform .5s;
  z-index: -1;
}
.slide-right-enter-to {
  transform: translateX(100vw);
}
.slide-right-leave-to {
  transform: translateX(40vw);
}
</style>


// WEBPACK FOOTER //
// src/components/SlideTransition.vue